/* src/app/module/shared/component/layout/sidebar/sidebar.component.scss */
.logo-container {
  display: inline-block;
}
.logo-container .app-version-indicator {
  font-size: 10px;
  text-align: right;
  color: rgba(0, 0, 0, 0.37);
}
.logo-container .logo-maennchen-headshot {
  border-radius: 100%;
}
.logo-container .logo-nur-schrift {
  margin-left: 3px;
}
@media (max-width: 665px) {
  .logo-container .logo-nur-schrift.show-md {
    display: none;
  }
}
html.nb-dark-theme app-navigation ion-title a {
  color: #fff;
}
/*# sourceMappingURL=sidebar.component.css.map */
